import { useState } from 'react';

export function useLocalStorage(key, initialState = null) {
  const [value, setValue] = useState(() => {
    try {
      const storedValue = window.localStorage.getItem(key);
      return storedValue ? JSON.parse(storedValue) : initialState;
    } catch (error) {
      console.error(`${error} - data could not be parsed into JSON`);
      return initialState;
    }
  });

  const setStoredValue = (newValue) => {
    setValue((previousValue) => {
      const resolvedValue = typeof newValue === 'function' ? newValue(previousValue) : newValue;
      try {
        window.localStorage.setItem(key, JSON.stringify(resolvedValue));
      } catch (error) {
        console.error(error);
      }
      return resolvedValue;
    });
  };

  return [value, setStoredValue];
}
